import script from "./shopping-cart.vue?vue&type=script&lang=jsx"
export * from "./shopping-cart.vue?vue&type=script&lang=jsx"

import "./shopping-cart.vue?vue&type=style&index=0&id=3abef316&lang=scss"

const __exports__ = script;

export default __exports__